import React from 'react';
import { useLocation } from 'react-router-dom';
import { QuizModalsInnerComponent } from './quiz-modals-inner-component';
export const QuizModals = (props) => {
    const location = useLocation();
    return React.createElement(QuizModalsInnerComponent, { url: location.pathname + location.search, ...props });
};
//# sourceMappingURL=quiz-modals.js.map